import { getDomain } from './domainMapping';

export interface CompanyMoneyFormat {
  decimalSeparator: string;
  numberOfDecimals: number;
  currency: string;
}

export interface CompanyMoneyFormatWithSymbol extends CompanyMoneyFormat {
  currencySymbol: string;
}

function getNumberFormatter(
  amount: number,
  currencyCode: string,
  numberOfDecimals: number
): string {
  const fullLocale = getDomain.getCurrentDomainSpec().FullLocale;

  if (amount % 1 === 0) {
    return new Intl.NumberFormat(fullLocale, {
      style: 'currency',
      currency: currencyCode,
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    }).format(amount);
  }

  return new Intl.NumberFormat(fullLocale, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: numberOfDecimals,
  }).format(amount);
}

export function formatWithCurrency(amount: number, currency?: string): string {
  return getNumberFormatter(
    amount,
    currency ?? getDomain.getCurrentDomainSpec().MoneyFormat.currency,
    getDomain.getCurrentDomainSpec().MoneyFormat.numberOfDecimals
  );
}
